/*
Copyright (C) 2023-2026 QuantumNous

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.

This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License
along with this program. If not, see <https://www.gnu.org/licenses/>.

For commercial licensing, please contact support@quantumnous.com
*/

// BizConsole modified 20260828: 从 NewAPI web/src/i18n/config.ts 派生;
// 语言收敛到 en/zhCN(zhCN 为默认,doc/049 D6);移除 LanguageDetector;
// 偏好存 localStorage["BizConsole-lang"],初始化时先读一次。
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./locales/en.json";
import zhCN from "./locales/zh.json";

export const resources = {
  en,
  zhCN,
} as const;

const storedLang = typeof window !== "undefined" ? window.localStorage?.getItem("BizConsole-lang") : null;
const initLang = storedLang === "en" || storedLang === "zhCN" ? storedLang : "zhCN";

i18n.use(initReactI18next).init({
  resources,
  lng: initLang,
  fallbackLng: "zhCN",
  supportedLngs: ["en", "zhCN"],
  load: "currentOnly",
  nsSeparator: false, // Allow literal colons in keys (e.g., URLs, labels)
  debug: import.meta.env.DEV,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
});

export type SupportedLang = "en" | "zhCN";

export function persistLang(lang: SupportedLang) {
  window.localStorage?.setItem("BizConsole-lang", lang);
}

export default i18n;
